<template>
  <li
    class="accordion-item"
    :class="{ 'is-open': isOpen }">
    <button
      class="accordion-item-header button-unstyled"
      :aria-controls="itemId"
      :aria-expanded="isOpen"
      :data-dm-type="title"
      @click="onToggleItem">
      <h3 class="accordion-item-title new-heading-3 mb-0">
        <span>{{ title }}</span>
        <div class="overflow-hidden">
          <span class="plus-minus"></span>
        </div>
      </h3>
    </button>
    <div
      :id="itemId"
      :style="{ '--accordion-item-height': contentHeight }"
      class="accordion-item-content"
      :aria-hidden="!isOpen"
      ref="content"
      @transitionend="onTransitionEnd">
      <slot />
    </div>
  </li>
</template>

<script setup>
import {
  computed, inject, onMounted, ref,
} from 'vue';
import debounce from 'lodash.debounce';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  defaultOpen: {
    type: Boolean,
    default: false,
  },
});

const { isOpenItem, toggleItem } = inject('accordion');
const content = ref(null);
const contentHeight = ref('auto');

onMounted(() => {
  if (props.defaultOpen) {
    toggleItem(props.title);
  }

  setTimeout(() => {
    updateContentHeight();
  }, 500);

  window.addEventListener('resize', debounce(updateContentHeight, 250), { passive: true });
});

const isOpen = computed(() => isOpenItem(props.title));
const itemId = computed(() => props.title.replace(/\W/g, '-').toLowerCase());

function onToggleItem() {
  toggleItem(props.title);
}

function updateContentHeight() {
  contentHeight.value = `${content.value.scrollHeight}px`;
}

function onTransitionEnd() {
  if (isOpen.value) {
    // content.value.parentElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
}
</script>
